import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode, SyntheticEvent, useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import { Text, TextSize } from '../Text/Text';
import { APIProductTypes } from 'app/api/APITypes';
import { formatNumber } from 'shared/lib/utils/utils';
import Icon from 'shared/assets/icons/selector-arrow.svg';
import Income from 'shared/assets/icons/HistoryPage/Income.svg';
import Outcome from 'shared/assets/icons/HistoryPage/outcome.svg';
import cls from './Dropdown.module.scss';

interface DropdownProps {
    transactions?: {
        date: string
        group: string
        level: number
        name: string
        product_category: null | string
        value: number
    }[],
    totalValue: number
}

export const Dropdown = ({ transactions, totalValue }: DropdownProps) => {
    const [isActive, setIsActive] = useState<boolean>(false);
    // const [ totalSum, setTotalSum ] = useState<number>(0);

    const titles = {
        income: `Доход за 4 года (${transactions[0].level} уровень)`,
        outcome: `Расход за 4 года (${transactions[0].level} уровень)`,
        credit1: `Кредит на покупку (${transactions[0].level} уровень)`,
        credit2: `Второй кредит на покупку (${transactions[0].level} уровень)`,
        parent_help: `Помощь от родителей за 4 года (${transactions[0].level} уровень)`,
        scholarship: `Стипендия за 4 года (${transactions[0].level} уровень)`,
        workWithGame: `Зарплата за 4 года (${transactions[0].level} уровень)`,
        broker: `Пополнение брокерского счета за 4 года (${transactions[0].level} уровень)`,
        dsj: `ДСЖ за 4 года (${transactions[0].level} уровень)`,
        nsj: `НСЖ за 4 года (${transactions[0].level} уровень)`,
        osago: `ОСАГО за 4 года (${transactions[0].level} уровень)`,
        dms: `ДМС за 4 года (${transactions[0].level} уровень)`,
        sjz: `СЖЗ за 4 года (${transactions[0].level} уровень)`,
        deposit: `Пополнение вклада за 4 года (${transactions[0].level} уровень)`,
        shop: `Покупки в магазине (${transactions[0].level} уровень)`,
        pi: `Оплата страхования имущества и гражданской ответственности (${transactions[0].level} уровень)`
        // credit: `Кредит на покупку за 4 года (${transactions[0].level} уровень)`,
    }

    return (
        <div>
            <div className={classNames(cls.header, { [cls.active]: isActive })} onClick={() => setIsActive(!isActive)}>
                <div className={cls.title}>
                    <Income className={cls.label}/>
                    <p>{
                        //@ts-ignore
                        titles[transactions[0].group]
                    }</p>
                    <Icon className={classNames(cls.icon, { [cls.activeIcon]: isActive })} />
                </div>
                <p className={cls.totalSum}>{formatNumber(totalValue)} ₽</p>
            </div>
            <Collapse isOpened={isActive}>
                <div className={cls.content}>
                    <ul className={cls.list}>
                        {
                            transactions && transactions.map(({ name, value }, index) => {
                                return (
                                    <li className={cls.item} key={index}>
                                        <p>{ name }</p>
                                        <p className={cls.sum}>{formatNumber(value)} ₽</p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </Collapse>
        </div>
    )
};
